// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3xSIg","selected":"Chip_selected__2Gqj5"};